import { action } from 'satcheljs';

export interface FeedbackRibbonClickProps {
    SessionId: string;
    Feature: string;
    RibbonResponse: string;
    SubFeature?: string;
    Metadata?: string;
}

export const logRibbonResponse = action(
    'logRibbonResponse',
    (feedbackRibbonClickResponse: FeedbackRibbonClickProps) => feedbackRibbonClickResponse
);
